module.exports = __webpack_public_path__ + "img/13n.534a000c.svg";